import { render, staticRenderFns } from "./ProductSplicing.vue?vue&type=template&id=5244453d&scoped=true"
import script from "./ProductSplicing.vue?vue&type=script&lang=js"
export * from "./ProductSplicing.vue?vue&type=script&lang=js"
import style0 from "./ProductSplicing.vue?vue&type=style&index=0&id=5244453d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5244453d",
  null
  
)

export default component.exports